import { render } from "./PublicationFeedGroupList.vue.js?vue&type=template&id=3b173ebc!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationFeedGroupList.vue?vue&type=template&id=3b173ebc"
import script from "./PublicationFeedGroupList.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationFeedGroupList.vue?vue&type=script&lang=js"
export * from "./PublicationFeedGroupList.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationFeedGroupList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/publication/PublicationFeedGroupList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b173ebc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b173ebc', __exports__)) {
    api.reload('3b173ebc', __exports__)
  }
  
  module.hot.accept("./PublicationFeedGroupList.vue.js?vue&type=template&id=3b173ebc!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationFeedGroupList.vue?vue&type=template&id=3b173ebc", () => {
    api.rerender('3b173ebc', render)
  })

}


export default __exports__